import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend
} from 'recharts';

interface RevenueData {
  name: string;
  value: number;
  color: string;
}

const data: RevenueData[] = [
  { 
    name: 'Regular Maintenance', 
    value: 35000, 
    color: 'hsl(221.2 83.2% 53.3%)'
  },
  { 
    name: 'Emergency Repairs', 
    value: 25000, 
    color: 'hsl(346 84% 61%)'
  },
  { 
    name: 'Inspections', 
    value: 15000, 
    color: 'hsl(142 72% 29%)'
  },
  { 
    name: 'Upgrades', 
    value: 20000, 
    color: 'hsl(48 96% 53%)'
  },
  { 
    name: 'Other Services', 
    value: 5000, 
    color: 'hsl(262 83% 58%)'
  },
];

export function RevenueBreakdown() {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Revenue by Service Type</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-8 md:grid-cols-2">
          {/* Chart */}
          <div className="h-[300px] w-full">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={80}
                  paddingAngle={2}
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell 
                      key={`cell-${index}`} 
                      fill={entry.color}
                      stroke="hsl(var(--background))"
                      strokeWidth={2}
                    />
                  ))}
                </Pie>
                <Tooltip
                  content={({ active, payload }) => {
                    if (active && payload?.length) {
                      const data = payload[0].payload;
                      const percentage = ((data.value / total) * 100).toFixed(1);
                      return (
                        <div className="rounded-lg border bg-background p-3 shadow-sm">
                          <div className="text-sm font-medium">{data.name}</div>
                          <div className="mt-1 space-y-1">
                            <div className="text-sm text-muted-foreground">
                              Amount: ${data.value.toLocaleString()}
                            </div>
                            <div className="text-sm text-muted-foreground">
                              Percentage: {percentage}%
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Legend */}
          <div className="flex flex-col justify-center space-y-4">
            {data.map((item) => (
              <div key={item.name} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div 
                    className="h-3 w-3 rounded-full"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="text-sm font-medium">{item.name}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium">
                    ${item.value.toLocaleString()}
                  </span>
                  <span className="text-sm text-muted-foreground">
                    ({((item.value / total) * 100).toFixed(1)}%)
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}